// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {SimSystemExtendedService} from "@services";
import {Translations} from "@translations";

export interface DialogData_JSONViewDialogInput extends MatDialogDataBaseInput {
	elementToShow: any;
}

export interface DialogData_JSONViewDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-json-view-dialog",
	templateUrl: "./json-view-dialog.component.html",
	styleUrls: ["./json-view-dialog.component.scss"],
	standalone: false,
})
export class JsonViewDialogComponent extends BasicMaterialDialog<
	JsonViewDialogComponent,
	DialogData_JSONViewDialogInput,
	DialogData_JSONViewDialogOutput
> {
	objAsJson: string = null;
	T = Translations;

	constructor(_injector: Injector) {
		super(_injector);

		this.objAsJson = JSON.stringify(this.data.elementToShow);
	}

	ngOnInit(): void {}
}
